module.exports = __webpack_public_path__ + "img/8.e2d7e4ad.png";